import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-brand-cream relative overflow-hidden" data-id="element-263">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl -z-10" data-id="element-264"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-265">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green" data-id="element-267">
            No vas a pagar{' '}
            <span className="line-through text-brand-red/80" data-id="element-268">$67</span>.
          </h2>
          <p className="text-xl md:text-2xl text-brand-gray/80 mb-8 max-w-2xl mx-auto" data-id="element-269">
            Solo para las próximas 20 mujeres. Después sube a $67.
          </p>
          <p className="text-lg text-brand-gray/70 italic border-b border-brand-gold/30 pb-8 inline-block" data-id="element-270">
            Porque mi misión es ayudar a 10,000 mujeres a recuperar su brillo
            este año...
          </p>
        </motion.div>

        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-2 border-brand-gold relative max-w-2xl mx-auto" data-id="element-271">
          {/* Badge */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brand-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-272">
            🔥 Edición 2026 — Cupos Limitados
          </div>

          <p className="text-brand-gray/60 uppercase tracking-widest font-semibold mb-2" data-id="element-273">
            Tu Precio Hoy
          </p>

          {/* Before price */}
          <div className="flex justify-center items-center gap-3 mb-3" data-id="element-274">
            <span className="text-2xl md:text-3xl text-brand-gray/40 line-through font-semibold" data-id="element-275">
              $67
            </span>
            <span className="bg-brand-red text-white text-sm md:text-base font-bold px-3 py-1 rounded-full" data-id="element-276">
              -60% OFF
            </span>
          </div>

          {/* Current price */}
          <div className="flex justify-center items-baseline gap-2 mb-2" data-id="element-277">
            <span className="text-6xl md:text-8xl font-black text-brand-green tracking-tighter" data-id="element-278">
              $27
            </span>
            <span className="text-xl text-brand-gray/50 font-medium" data-id="element-279">USD</span>
          </div>

          <p className="text-sm text-brand-green/70 font-semibold mb-8" data-id="element-280">
            ¡Ahorras $40 hoy!
          </p>

          <p className="text-brand-gray/70 mb-8 text-lg" data-id="element-281">
            (Menos de lo que cuesta una cena fuera que probablemente inflamará
            tus hormonas).
          </p>

          {/* Bonuses included */}
          <div className="mb-8 text-left" data-id="element-282">
            <p className="text-xs uppercase tracking-widest text-brand-gray/50 font-semibold mb-4 text-center" data-id="element-283">
              Incluye 5 bonos gratis
            </p>
            <div className="space-y-2" data-id="element-284">
              {[{
              img: 'https://cdn.magicpatterns.com/uploads/2uD8L1BXdF5qqHZ2WWP7bG/BONO_1.png',
              name: 'SOS Sofocos y Ansiedad Nocturna'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/3JTWKuqgSj6SEnwXJyqy4w/BONO_2.png',
              name: 'Lista de Compras Hormone-Safe'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/e6aheqcGeZZRgXdBSTshdT/BONO_3.png',
              name: 'Recetario "Cenas en 10 Minutos"'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/aktpvGH7tTQw8jRme9mdzG/BONO_4.png',
              name: 'Guía de Suplementación Estratégica'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/aMgZNPHZ5CQEtBUfHUd3zB/BONO_5.png',
              name: 'Protocolo de Magnesio para el Sueño'
            }].map((bonus, i) => <div key={i} className="flex items-center gap-3 bg-brand-cream/50 rounded-xl p-2.5" data-id="element-285">
                  <img src={bonus.img} alt={bonus.name} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" data-id="element-286" />
                  <span className="text-sm text-brand-gray/80 font-medium" data-id="element-287">
                    {bonus.name}
                  </span>
                </div>)}
            </div>

            {/* Bono Especial */}
            <div className="mt-4 flex items-center gap-3 bg-brand-gold/15 rounded-xl p-2.5 border border-brand-gold/30" data-id="element-288">
              <img src="https://cdn.magicpatterns.com/uploads/iqHCo97tezJnqyAMWLBT9F/IMAGEN_-_BONO_1.png" alt="Plan Anti-Caos 7 Días (40+)" className="w-10 h-10 rounded-lg object-cover flex-shrink-0" data-id="element-289" />
              <div data-id="element-290">
                <span className="text-sm text-brand-green font-bold block" data-id="element-291">
                  Plan Anti‑Caos 7 Días (40+)
                </span>
                <span className="text-xs text-brand-gold font-semibold" data-id="element-292">
                  BONO ESPECIAL — GRATIS
                </span>
              </div>
            </div>
          </div>

          <CTAButton className="mb-6" href="https://optilatammarket.com/cart/42615614439522:1" data-id="element-293">
            SÍ, QUIERO EL CÓDIGO HORMONAL
          </CTAButton>

          <div className="flex flex-col gap-3 text-brand-gray/70 text-sm mt-8 text-left max-w-md mx-auto" data-id="element-294">
            <div className="flex items-start gap-3" data-id="element-295">
              <Lock className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-296" />
              <span data-id="element-297">
                Pago 100% seguro y protegido por Shopify Payments y PayPal.
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-298">
              <ShieldCheck className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-299" />
              <span data-id="element-300">
                Acceso inmediato — recibes todo en tu correo en segundos.
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-301">
              <CreditCard className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-302" />
              <span data-id="element-303">Soporte directo — respondemos en menos de 24 horas.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}